export const firebaseConfig = {
  apiKey: 'AIzaSyDdvUrb4AmF98_ZHUAmihfpa0SVNDrWX8w',
  authDomain: 'sunrises-gabura-d037b.firebaseapp.com',
  projectId: 'sunrises-gabura-d037b',
  storageBucket: 'sunrises-gabura-d037b.appspot.com',
  messagingSenderId: '327394353432',
  appId: '1:327394353432:web:07f0a671777c670ba73e6d',
};
